import './index.css'
import React from 'react';
import Autocomplete from '../common/Autocomplete';
import RichEditor from '../common/RichEditor';


export default function BasicForm(props: any) {
  const action = props.action
  const handleChange = props.handleChange
  const handleSelection = props.handleSelection
  const ticketCloseForm = props.ticketCloseForm
  const closingCausesList = props.closingCausesList

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>DATOS BÁSICOS</p>
        </div>
        <div className='tkt-form-section-item'>
          <Autocomplete
            label='Causa de Cierre'
            placeholder='Causa de Cierre'
            name='closing_cause'
            disabled={action === "view"}
            options={closingCausesList}
            value={ticketCloseForm.closing_cause}
            handleSelection={handleSelection}
            required
          />
        </div>
      </div>

      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <br /><p>DESCRIPCIÓN</p>
        </div>
        <div className='tkt-form-section-item__desc'>
          <RichEditor
            name="description"
            value={ticketCloseForm.description}
            disabled={action === "view"}
            handleChange={handleChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
